var _jsxFileName = "/media/data/Sandbox/soapbox-defake/app/soapbox/features/compose/components/compose-form-button.tsx";
import classNames from 'clsx';
import React from 'react';
import { IconButton } from 'soapbox/components/ui';

const ComposeFormButton = _ref => {
  let {
    icon,
    title,
    active,
    disabled,
    onClick
  } = _ref;
  return /*#__PURE__*/React.createElement("div", {
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 22,
      columnNumber: 5
    }
  }, /*#__PURE__*/React.createElement(IconButton, {
    className: classNames({
      'text-gray-600 hover:text-gray-700 dark:hover:text-gray-500': !active,
      'text-primary-500 hover:text-primary-600 dark:text-primary-500 dark:hover:text-primary-400': active
    }),
    src: icon,
    title: title,
    disabled: disabled,
    onClick: onClick,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 23,
      columnNumber: 7
    }
  }));
};

export default ComposeFormButton;